import React, { Component } from 'react';
import { StateContext } from "../../../state";
import Button, { ButtonContainer } from "../../library/Buttons";
import StartOver from '../../library/StartOver';
import { Translation } from 'react-i18next';
import { substituteVariablesInString } from "../../../utils/substitutions";
import { get } from 'lodash/object';

const DEFAULT_TIME_BEFORE_AUTO_ACCEPT_IN_SECONDS = 10;

export class AutoAcceptFlow extends Component {
  constructor(props, context){
    super(props);
    const [{configuration}] = context;
    const autoAcceptDurationInSeconds = get(configuration, 'acceptPayment.autoAcceptDurationInSeconds', DEFAULT_TIME_BEFORE_AUTO_ACCEPT_IN_SECONDS);

    this.state = {
      timeRemaining: autoAcceptDurationInSeconds,
      isFetching: false,
    };
  }

  onManualAccept = evt => {
    if(this.intervalId){
      clearInterval(this.intervalId);
    }
    this.setState({isFetching: true, intervalId: null,});
    this.props.acceptPayment();
  };

  onTimeExpired = () => {
    if(this.intervalId){
      clearInterval(this.intervalId);
    }
    this.setState({isFetching: true});
    const additionalDataForLogs = {acceptanceActionType: 'auto-accept'};
    this.props.acceptPayment(null, additionalDataForLogs);
  };

  componentDidMount(){
    this.intervalId = setInterval(() => {
      const timeRemaining = this.state.timeRemaining - 1;

      if(!timeRemaining){
        this.onTimeExpired()
      }
      else {
        this.setState({timeRemaining});
      }
    }, 1000);
  }

  componentWillUnmount(){
    if(this.intervalId){
      clearInterval(this.intervalId);
    }
  }

  render(){
    const [{configuration, payment, paymentNetworkConfig}] = this.context;
    const dataForVariableSubstitutions = {payment, paymentNetwork: paymentNetworkConfig};
    const label = substituteVariablesInString(configuration.acceptPayment.btnLabel, dataForVariableSubstitutions);
    const {timeRemaining, isFetching} = this.state;
    const View = this.props.children;

    return (
      <View>
        <ButtonContainer>
          <Button
            onClick={this.onManualAccept}
            label={label}
            disabled={isFetching}
          />
        </ButtonContainer>
        <Translation>
          {t => <StartOver disabled={isFetching}>{`${t('chooseDifferentPaymentOption')} (${timeRemaining})`}</StartOver>}
        </Translation>
      </View>
    )
  }
}

AutoAcceptFlow.contextType = StateContext;

export default AutoAcceptFlow;
